export default (props)=>{
    const colorClass = props.color?' has-'+props.color+'-color':' no-color';
    const backgroundColorClass = props.backgroundColor?' has-'+props.backgroundColor+'-background-color':' no-background-color';
    const fixed_size = props.fixedSize?' fa-fw':'';
    return <i className={ 'cdm-font-awesome'+colorClass+backgroundColorClass+fixed_size+' size-icon-'+props.size+' fa-'+props.style+' '+'fa-'+props.iconId + ' has-text-align-'+(props.align ?? 'left')}></i>
}
